export default {"src":"/_next/static/media/ella-flower.209c8012.svg","height":29,"width":31,"blurWidth":0,"blurHeight":0};